'use strict';

var $ = require('jquery');

$(function(){
	$('.cookie-warning').on('click','.ok',function(){
		setConsentCookie();
		$('.cookie-warning').hide();
	});
});

function setConsentCookie(){
	var expDate = new Date();
	expDate.setFullYear(expDate.getFullYear() + 1);
	document.cookie = "gwwp_cookie_consent=true; path=/; expires=" + expDate.toGMTString();
}